"use strict";

import Vue from 'vue'

$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    //if token= param exist, replace with ''
    var index = ''
    var token_val = ''
    var valid = ''
    if(settings.data){
      var url = settings.data
    } else if (settings.type == 'GET') {
      var url = settings.url
    }
    // console.log('U:'+JSON.stringify(settings))
    // console.log('V: '+url)
    if(url){
      var valid = url.indexOf("&")
      if(valid >= 0){
        var suburl = url.split('&')
        var delimiter = '&'
      } else {
        var suburl = url.split('?')
        var delimiter = '?'
      }

      suburl.forEach(function(value, i){
        if(value.substring(0,6) == 'token='){
          index = i
          token_val = value.split('=')
          if(settings.data){
            settings.data = url.replace(delimiter + suburl[index], "")
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "")
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      })
    }
    
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () { return $('meta[name="csrf_name"]').attr('content'); }(),
          'csrf_value': function () { return $('meta[name="csrf_value"]').attr('content'); }()
        };
        settings.data += '&' + $.param(csrf);
      }
      return true;
    }
  },
})

$(document).ajaxSuccess(function(event, xhr, options) {
  if(!_.isUndefined(xhr.responseJSON)) {
    if(xhr.responseJSON.redirect){
      window.location.href = xhr.responseJSON.redirect;
    }
  }
})

$(document).ajaxComplete(function(event, xhr, options) {
  if (xhr.getResponseHeader('X-Auth') == '0') {
      window.location = 'login';
  }

  if(xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')){
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
})

Vue.prototype.$ajax = $.ajax



// WEBPACK FOOTER //
// ./resources/wob/js/core/ajax-http-interceptor.js